query BusinessUnitsTableData(
  $days: Int!
  $customFieldsFilter: ConditionStringArray
  $customFieldsFilterExcludes: ConditionStringArray
  $calculationDateFrom: ConditionDateTime
  $calculationDateTo: ConditionDateTime
) {
  # Web SDK Tests - Both critical and serious issues for all business units
  wsdkIssuesCount: wsdk_test_runs(
    run_time_last_n_days: { value: [$days] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: filtered_custom_fields
  ) {
    filtered_custom_fields(key:"unitId")
    critical_issues_sum
    serious_issues_sum
  }
  
  # WFA Sessions - Both critical and serious issues for all business units
  wfaIssuesCount: wfa_session_runs(
    run_time_last_n_days: { value: [$days] }
    custom_fields_eq_any_item_for_any_value: $customFieldsFilter
    custom_fields_ne_any_item_for_any_value: $customFieldsFilterExcludes
    group: filtered_custom_fields
  ) {
    filtered_custom_fields(key:"unitId")
    critical_issues_sum
    serious_issues_sum
  }

  score_web_products(
    calculation_date_ge: $calculationDateFrom
    calculation_date_le: $calculationDateTo
  ) {
    unit_id
    environment
    timeframe_days
    unique_issues
    score
    calculation_date
  }
}
